<template>
  <v-container style="height: 200px;">
    <v-row class="fill-height" align-content="center" justify="center">
      <v-col class="text-subtitle-1 text-center" cols="12">
        {{ title }}
      </v-col>
      <v-col cols="5">
        <v-progress-linear background-color="#D3D3D3" class="progress" color="success" :value="count" height="20">
          <span class="white--text">{{ count ? count : 0 }}%</span>
        </v-progress-linear>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {
    title: String,
    count: String
  }
}
</script>
<style scoped>
.progress {
  border-radius: 10px;
}
</style>
